package api

import kotlinx.serialization.Serializable

@Serializable
sealed class ApiNotificatoin {
    @Serializable
    data class BalanceChanged(val wallet: ApiWallet): ApiNotificatoin()
}